// extracted by mini-css-extract-plugin
module.exports = {"Login":"styles_Login__1iMa2","LoginContainer":"styles_LoginContainer__u1JXV","error":"styles_error__2hTKL","signupLink":"styles_signupLink__3WtdN"};